import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { updateItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import SaleOrder from "../../models/sale-order";

interface SaleOrderRevertModalProps {
  show: boolean;
  saleOrder?: SaleOrder;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const SaleOrderRevertModal: React.FC<SaleOrderRevertModalProps> = ({
  show,
  saleOrder,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = saleOrder
    ? `Está seguro de que quiere revertir/anular la venta #${saleOrder.id}, ${saleOrder.clientName}`
    : "";

  const onSubmitClick = async () => {
    if (saleOrder !== undefined) {
      setSubmitting(true);

      let toSendSaleOrder: SaleOrder = {
        ...saleOrder,
      };
      const orderStatus = await updateItem<SaleOrder>(
        `/sale_orders/${saleOrder.id}/revert/`,
        toSendSaleOrder
      );

      if (orderStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (orderStatus.errors !== undefined) {
        }
        if (orderStatus.detail !== undefined) {
          message = orderStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-warning" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Revertir/anular Venta</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
              <p>
                {" "}
                Al revertir/anular la venta todos los envios relacionados
                también seran revertidos
              </p>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onSubmitClick} color="warning">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Revirtiendo..." : "Revertir"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default SaleOrderRevertModal;
